<template>
  <div>
    <v-container grid-list-xl fluid class="white pl-6 pr-5 pb-0">
      <v-layout row wrap class="pr-5 pl-2 mb-2">
        <v-flex class="py-0">
          <h2 class="primary--text breadcrumbs fs-16 lh-29 font-weight-700">
            Spending Approval
          </h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-breadcrumbs
          class="px-0 fs-12 lh-15 py-0 breadcrumbs-items custom-breadcrumbs"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-layout>
      <!-- summary total amount -->
      <v-layout row wrap class="px-5">
        <v-expansion-panels
          flat
          v-model="panelSummary"
          multiple
          class="summary-collapse rounded-0"
          :class="panelSummary.length > 0 ? '' : 'border-y-2'"
        >
          <v-expansion-panel class="rounded-0">
            <v-expansion-panel-content>
              <v-flex xs12 class="py-0">
                <v-row class="spending-info pa-0">
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="teal"
                      :typeCard="1"
                      :value1="summaryAmount.totalBudget"
                      :valueEur="summaryAmount.totalBudgetEuro"
                      text="TOTAL BUDGET"
                      textColor="teal--text"
                      style="border-right: 1px solid #bdbdbd !important"
                    ></summary-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="softRed"
                      textColor="softRed--text"
                      :typeCard="2"
                      :value1="summaryAmount.totalSpending"
                      :valueTotal="summaryAmount.totalBudget"
                      :valueEur="summaryAmount.totalSpendingEuro"
                      text="TOTAL SPENDING IO"
                      style="border-right: 1px solid #bdbdbd !important"
                    ></summary-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" class="px-0">
                    <summary-amount
                      colour="bluePurple"
                      textColor="bluePurple--text"
                      :typeCard="3"
                      :value1="summaryAmount.remaining"
                      :valueTotal="summaryAmount.totalBudget"
                      :valueEur="summaryAmount.remainingEuro"
                      text="TOTAL REMAINING BUDGET"
                    ></summary-amount>
                  </v-col>
                </v-row>
              </v-flex>
            </v-expansion-panel-content>
            <v-expansion-panel-header class="py-2">
              <template v-slot:actions class="mx-auto">
                <v-icon
                  color="bluedarken"
                  style="font-size: 23px !important"
                  class="mx-auto"
                >
                  keyboard_arrow_down
                </v-icon>
              </template>
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-layout>
      <!-- /summary total amount -->
    </v-container>
    <v-layout class="tab-spending">
      <v-tabs v-model="tab" background-color="white" color="menuActive">
        <v-tabs-slider></v-tabs-slider>
        <v-tab
          v-for="(item, index) in filters"
          :key="index"
          align-with-title
          @click="setFilter(item, index)"
          class="text-left px-0 d-block pt-3 mr-10"
          style="min-width: 120px !important; height: 100%"
        >
          <span
            v-if="item.name === 'House/Dept'"
            class="text-capitalize fs-12 font-weight-600 text-left"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ item.name }}
                </span>
              </template>
              <span>
                House refer to Marketing Division and Dept refer to HN Division
              </span>
            </v-tooltip>
          </span>
          <span
            v-else-if="item.name === 'Dept/Category'"
            class="text-capitalize fs-12 font-weight-600 text-left"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ item.name }}
                </span>
              </template>
              <span>
                Dept refer to Marketing Division and Category refer to HN
                Division
              </span>
            </v-tooltip>
          </span>
          <span v-else class="text-capitalize fs-12 font-weight-600 text-left">
            {{ item.name }}
          </span>
        </v-tab>
        <v-spacer></v-spacer>
        <dialog-advance-filter
          v-if="filters[0].value !== 'budgetOwner'"
          title="Spending Approval"
          @paramAdvanceFilter="getParam"
          @getSummary="getSummaryAmount"
          @resetTab="resetTab"
          @setTab="setTab"
          @openDialog="openFilterDialog"
        />
        <!-- <v-btn
          class="primary text-capitalize f-14 lh-17 mt-3 mr-2"
          @click="openFilterDialog"
        >
          <v-icon>mdi-filter-outline</v-icon> Filter
        </v-btn> -->
        <!-- <v-btn
          id="btn-download"
          depressed
          color="primary"
          class="white--text mt-3 mr-2"
        >
          <v-icon left dark>vertical_align_bottom</v-icon>
          Download
        </v-btn> -->
        <!-- <v-flex xs2 class="text-center pb-0 pt-3"> -->
        <date-picker
          v-model="year"
          type="year"
          placeholder="Filter"
          format="YYYY"
          class="dashSearch filterSearch mt-3"
          style="width: 135px !important"
          @change="setFilter()"
        >
        </date-picker>
        <!-- </v-flex> -->
        <v-tabs-items v-model="tab">
          <template v-if="items.length == 0">
            <v-tab-item v-for="(tab, index) in tabItems" :key="index">
              <v-layout class="px-7 mt-3">
                <v-flex xs12>
                  <v-card class="pb-4 rounded-10 elevation-card">
                    <v-card-title class="primary pa-2 white--text">
                      <span id="titleBrand" class="title pl-2"></span>
                      <v-spacer></v-spacer>
                      <v-icon class="mr-4" color="white" id="removeBudget"
                        >keyboard_arrow_down</v-icon
                      >
                      <v-icon
                        color="white"
                        class="mr-2"
                        id="refreshBudget"
                        @click="setFilter()"
                        >refresh</v-icon
                      >
                    </v-card-title>
                    <v-card-text class="pa-3">
                      <v-layout row wrap class>
                        <v-icon color="primary" class="ml-3 pt-0 bg-info">
                          info
                        </v-icon>
                        <span
                          class="
                            pl-2
                            font-weight-medium
                            subtitle-1
                            darkblue--text
                          "
                        >
                          SPENDING INFORMATION
                        </span>
                        <v-flex xs12 class="py-0 text-center">
                          No data displayed
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </template>
          <v-tab-item
            v-else
            v-for="(tabs, index) in tabItems"
            :key="index"
            class="px-8"
          >
            <v-layout
              v-for="(item, index) in tabs.data"
              :key="index"
              row
              wrap
              class="pt-5 px-3"
            >
              <span
                v-if="isLoggedInAsFinance"
                class="font-weight-700 fs-20 lh-16 pl-1 bluedarken--text"
                style="align-self: center"
              >
                {{
                  item.type === 'department'
                    ? item.name
                    : item.filterBy === 'house'
                    ? item.name + ' (Exclude HN)'
                    : item.name
                }}
              </span>
              <span
                v-else
                class="font-weight-700 fs-20 lh-16 pl-1 bluedarken--text"
                style="align-self: center"
              >
                {{ item.name || '-' }}
              </span>
              <v-spacer></v-spacer>
              <v-icon
                color="bluedarken"
                @click="setFilter()"
                style="font-size: 22px !important"
                id="refreshBudget"
              >
                refresh
              </v-icon>
              <!-- card amount -->
              <v-flex xs12 class="pa-0 pt-2">
                <v-row class="spending-info pa-0">
                  <v-col cols="12" sm="6" md="4">
                    <card-amount
                      colour="softGreen"
                      :typeCard="1"
                      :value1="item.totalBudget"
                      :valueEur="item.totalBudgetEur"
                      text="BUDGET"
                      textColor="softGreen--text"
                    ></card-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <card-amount
                      colour="softRed"
                      textColor="softRed--text"
                      :typeCard="2"
                      :value1="item.totalSpending"
                      :valueTotal="item.totalBudget"
                      :valueEur="item.spentEur"
                      text="SPENDING IO"
                    ></card-amount>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <card-amount
                      colour="bluePurple"
                      textColor="bluePurple--text"
                      :typeCard="3"
                      :value1="item.remainingBudget"
                      :valueTotal="item.totalBudget"
                      :valueEur="item.remainingEur"
                      text="REMAINING BUDGET"
                    ></card-amount>
                  </v-col>
                </v-row>
              </v-flex>
              <!-- /card amount -->
              <v-flex xs12>
                <v-card flat tile style="background: transparent !important">
                  <v-card-text class="px-0">
                    <v-expansion-panels width="100%">
                      <v-expansion-panel
                        @click="getTable(item)"
                        class="mb-5 rounded-10 elevation-card"
                        width="100%"
                      >
                        <v-expansion-panel-header
                          expand-icon="keyboard_arrow_down"
                          class="
                            white
                            bluedarken--text
                            pr-5
                            pl-0
                            py-0
                            rounded-bottom-left-10 rounded-bottom-right-10
                          "
                        >
                          <template v-slot:actions>
                            <v-icon
                              color="bluedarken"
                              style="font-size: 23px !important"
                            >
                              keyboard_arrow_down
                            </v-icon>
                          </template>
                          <template>
                            <v-row no-gutters>
                              <div>
                                <img
                                  src="@/assets/images/icon/file-text-blue.png"
                                  class="ml-3 mt-1"
                                  style="margin-left: 14px !important"
                                  width="20px"
                                />
                              </div>
                              <span
                                class="
                                  pl-2
                                  font-weight-bold
                                  fs-14
                                  bluedarken--text
                                  align-self-center
                                  text-capitalize
                                "
                              >
                                {{
                                  item.name === 'HN'
                                    ? 'Department'
                                    : item.type === 'department' &&
                                      item.filterBy === 'house'
                                    ? 'Category'
                                    : filterName
                                }}
                              </span>
                            </v-row>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="pa-0">
                          <v-card-text class="px-0 pt-1">
                            <v-layout
                              v-if="
                                item.isInformation &&
                                  filterName === 'Spending by Taxonomy'
                              "
                              row
                              wrap
                              px-3
                            >
                              <v-icon color="primary" class="bg-info">
                                info
                              </v-icon>
                              <span
                                class="
                                  pl-2
                                  font-weight-medium
                                  subtitle-1
                                  darkblue--text
                                "
                                >SPENDING INFORMATION</span
                              >
                              <v-flex xs12 class="py-0">
                                <table width="80%" class="greydark--text">
                                  <tr>
                                    <td width="7%" class="font-weight-bold">
                                      House
                                    </td>
                                    <td
                                      v-if="item.dataIO[0]"
                                      width="15%"
                                      id="nameHouse"
                                    >
                                      {{
                                        item.dataIO[0].brand.house
                                          ? item.dataIO[0].brand.house.name
                                          : '-'
                                      }}
                                    </td>
                                    <td v-else width="15%" id="nameHouse">-</td>
                                    <td width="14%" class="font-weight-bold">
                                      Date Created
                                    </td>
                                    <td width="25%" id="dateCreated">
                                      {{
                                        item.dataIO[0].created_at
                                          ? item.dataIO[0].created_at
                                          : '-'
                                      }}
                                    </td>
                                    <td width="16%" class="font-weight-bold">
                                      Last Approval
                                    </td>
                                    <td width="22%" id="lastApproval">
                                      {{
                                        item.dataIO[0]
                                          ? item.dataIO[0].updated_at
                                          : '-'
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td width="7%" class="font-weight-bold">
                                      Brand
                                    </td>
                                    <td
                                      v-if="item.dataIO[0].brand"
                                      width="15%"
                                      id="nameBudget"
                                    >
                                      {{
                                        item.dataIO[0].brand
                                          ? item.dataIO[0].brand.name
                                          : '-'
                                      }}
                                    </td>
                                    <td v-else>-</td>
                                    <td width="14%" class="font-weight-bold">
                                      Last Changed
                                    </td>
                                    <td width="25%" id="dateUpdated">
                                      {{
                                        item.dataIO[0]
                                          ? item.dataIO[0].updated_at
                                          : '-'
                                      }}
                                    </td>
                                    <td width="16%" class="font-weight-bold">
                                      Budget ID
                                    </td>
                                    <td width="10%" id="budgetId">
                                      {{
                                        item.dataIO[0]
                                          ? item.dataIO[0].code
                                          : '-'
                                      }}
                                    </td>
                                  </tr>
                                </table>

                                <hr class="hr-line" style="" />
                              </v-flex>
                            </v-layout>
                            <!-- /budget info -->

                            <!-- list house -->
                            <v-row v-if="item.showHouse">
                              <v-col sm="12" class="pt-0">
                                <table-div
                                  :itemData="item"
                                  :itemPart="item.house"
                                  title="house"
                                  :text="
                                    item.type === 'department'
                                      ? 'Department'
                                      : 'House'
                                  "
                                  @selectAll="selectHouse"
                                  @checkSelect="checkSelect"
                                  @getDetailApproval="getDetailApproval"
                                  @modalNotes="modalNotes"
                                  @confirmRejectHouseDept="
                                    confirmRejectHouseDept
                                  "
                                  @confirmApproveHouseDept="
                                    confirmApproveHouseDept
                                  "
                                />
                              </v-col>
                            </v-row>
                            <!-- /list house -->

                            <!-- list department -->
                            <v-row v-if="item.showDept">
                              <div
                                v-if="
                                  filterName !== 'Category' &&
                                    filterName !== 'department'
                                "
                              >
                                <img
                                  src="@/assets/images/icon/file-text-blue.png"
                                  class="ml-2 mt-1"
                                  style="margin-left: 10px !important"
                                  width="20px"
                                />
                              </div>
                              <span
                                v-if="
                                  filterName !== 'Category' &&
                                    filterName !== 'department'
                                "
                                class="
                                  pl-2
                                  font-weight-bold
                                  fs-14
                                  bluedarken--text
                                  align-self-center
                                "
                              >
                                {{
                                  item.name === 'HN' ? 'Category' : 'Department'
                                }}
                              </span>
                              <v-col sm="12" class="pt-1">
                                <table-div
                                  :itemData="item"
                                  :itemPart="item.dept"
                                  title="dept"
                                  :text="
                                    item.type === 'department'
                                      ? 'Category'
                                      : 'Department'
                                  "
                                  @selectAll="selectDept"
                                  @checkSelect="checkSelect"
                                  @getDetailApproval="getDetailApproval"
                                  @modalNotes="modalNotes"
                                  @confirmRejectHouseDept="
                                    confirmRejectHouseDept
                                  "
                                  @confirmApproveHouseDept="
                                    confirmApproveHouseDept
                                  "
                                />
                              </v-col>
                            </v-row>
                            <!-- list budget owner -->
                            <v-row v-if="item.showBO">
                              <div v-if="filterName !== 'Budget Owner'">
                                <img
                                  src="@/assets/images/icon/file-text-blue.png"
                                  class="ml-2 mt-1"
                                  style="margin-left: 10px !important"
                                  width="20px"
                                />
                              </div>
                              <span
                                v-if="filterName !== 'Budget Owner'"
                                class="
                                  pl-2
                                  font-weight-bold
                                  fs-14
                                  bluedarken--text
                                  align-self-center
                                "
                              >
                                Budget Owner
                              </span>
                              <v-col sm="12" class="pt-1 table-approve pb-0">
                                <!-- <table-div
                                  :itemData="item"
                                  :itemPart="item.budgetOwners"
                                  title="budgetowner"
                                  @selectAll="selectAllBO"
                                  @checkSelect="checkSelect"
                                  @getDetailApproval="getIO"
                                  @modalNotes="modalNotes"
                                  @confirmRejectHouseDept="confirmRejectBO"
                                  @confirmApproveHouseDept="confirmApproveBO"
                                /> -->
                                <template>
                                  <v-simple-table
                                    class="spending-table nav-table"
                                  >
                                    <template v-slot:default>
                                      <thead width="100%">
                                        <tr width="100%" class="primary">
                                          <th
                                            width="42px"
                                            style="padding: 0px 17px !important"
                                          >
                                            <label class="form-checkbox">
                                              <input
                                                class="checkbox-approval"
                                                type="checkbox"
                                                v-model="item.selectAllBO"
                                                @click="selectBO(item)"
                                              />
                                              <span class="checkbox-custom">
                                              </span>
                                            </label>
                                          </th>
                                          <th class="f-14">
                                            Budget Owner Name
                                          </th>
                                          <th class="f-14">Total Budget</th>
                                          <th class="f-14">Total Spending</th>
                                          <th class="f-14">Total Remaining</th>
                                          <th class="f-14" width="10%">
                                            Notes
                                          </th>
                                        </tr>
                                      </thead>
                                      <VuePerfectScrollbar
                                        class="drawer-menu--scroll"
                                        :settings="scrollSettings"
                                      >
                                        <tbody
                                          v-if="item.budgetOwners.length > 0"
                                        >
                                          <tr
                                            v-for="bo in item.budgetOwners"
                                            :key="bo.id"
                                            style="cursor: pointer"
                                            :class="bgStatus(bo.status)"
                                          >
                                            <td
                                              width="41px"
                                              style="
                                                padding: 0px 16px !important;
                                              "
                                            >
                                              <v-layout align-center>
                                                <label class="form-checkbox">
                                                  <input
                                                    class="checkbox-approval"
                                                    type="checkbox"
                                                    :value="bo.id"
                                                    v-model="item.BOselected"
                                                  />
                                                  <span class="checkbox-custom">
                                                  </span>
                                                </label>
                                              </v-layout>
                                            </td>
                                            <td
                                              :class="
                                                bgActive(item.boActive, bo.id)
                                              "
                                              @click="
                                                getIO({
                                                  item: bo,
                                                  itemParent: item
                                                })
                                              "
                                            >
                                              {{ bo.name }}
                                            </td>
                                            <td
                                              :class="
                                                bgActive(item.boActive, bo.id)
                                              "
                                              @click="
                                                getIO({
                                                  item: bo,
                                                  itemParent: item
                                                })
                                              "
                                              class="text-right"
                                            >
                                              {{ idr(bo.totalBudget) }}
                                            </td>
                                            <td
                                              :class="
                                                bgActive(item.boActive, bo.id)
                                              "
                                              @click="
                                                getIO({
                                                  item: bo,
                                                  itemParent: item
                                                })
                                              "
                                              class="text-right"
                                            >
                                              {{ idr(bo.totalSpending) }}
                                            </td>
                                            <td
                                              :class="
                                                bgActive(item.boActive, bo.id)
                                              "
                                              @click="
                                                getIO({
                                                  item: bo,
                                                  itemParent: item
                                                })
                                              "
                                              class="text-right"
                                            >
                                              {{ idr(bo.remaining) }}
                                            </td>
                                            <td width="10%" class="text-center">
                                              <v-btn
                                                x-small
                                                class="ma-2"
                                                text
                                                icon
                                                color="secondblue"
                                                @click="
                                                  modalNotes(
                                                    bo,
                                                    item,
                                                    'budgetowner'
                                                  )
                                                "
                                              >
                                                <v-icon x-small>
                                                  mdi-square-edit-outline
                                                </v-icon>
                                              </v-btn>
                                            </td>
                                          </tr>
                                        </tbody>
                                        <tbody v-else>
                                          <tr>
                                            <td
                                              colspan="6"
                                              class="text-center pt-2"
                                            >
                                              <span>No Data Displayed</span>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </VuePerfectScrollbar>
                                    </template>
                                  </v-simple-table>
                                </template>
                              </v-col>
                              <v-flex xs12 class="text-right px-2 pb-2">
                                <v-btn
                                  class="ma-2 white--text"
                                  color="#bd1e19"
                                  :disabled="item.BOselected.length < 1"
                                  @click="confirmRejectBO(item)"
                                >
                                  Reject
                                </v-btn>
                                <v-btn
                                  primary
                                  class="primary ma-2"
                                  :disabled="item.BOselected.length < 1"
                                  @click="confirmApproveBO(item)"
                                >
                                  Approve
                                </v-btn>
                              </v-flex>
                            </v-row>
                            <!-- list io -->
                            <v-row v-if="item.showIO">
                              <div v-if="filterName !== 'Spending by Taxonomy'">
                                <img
                                  src="@/assets/images/icon/file-text-blue.png"
                                  class="ml-2 mt-1"
                                  style="margin-left: 10px !important"
                                  width="20px"
                                />
                              </div>
                              <span
                                v-if="filterName !== 'Spending by Taxonomy'"
                                class="
                                  pl-2
                                  font-weight-bold
                                  fs-14
                                  bluedarken--text
                                  align-self-center
                                "
                              >
                                Spending by Taxonomy
                              </span>
                              <v-spacer></v-spacer>
                              <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    id="btn-column"
                                    class="primary--text pb-0 mr-3"
                                    depressed
                                    color="lightblue"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    Select Column
                                  </v-btn>
                                </template>

                                <!-- <v-list>
                                  <v-list-item
                                    v-for="(colum, index) in spendingColumn"
                                    :key="'select' + index"
                                    @click="hideColum(item)"
                                  >
                                    <v-list-item-title>
                                      
                                      {{ colum.title }}
                                    </v-list-item-title>
                                  </v-list-item>
                                </v-list> -->
                                <v-list-item-group
                                  v-model="columnActive"
                                  multiple
                                  class="menuColumn"
                                >
                                  <VuePerfectScrollbar
                                    class="drawer-column--scroll"
                                    :settings="scrollSettings"
                                  >
                                    <div
                                      class="px-4 py-2"
                                      @click="selectAllColumn()"
                                      style="cursor: pointer"
                                    >
                                      <v-row>
                                        <v-flex
                                          xs2
                                          class="ml-4"
                                          style="max-width: 37px !important"
                                        >
                                          <v-icon
                                            v-if="selectedAllColumn"
                                            color="primary accent-4"
                                          >
                                            check_box
                                          </v-icon>
                                          <v-icon
                                            color="primary accent-4"
                                            v-else
                                          >
                                            check_box_outline_blank
                                          </v-icon>
                                        </v-flex>
                                        <v-flex xs8 class="pt-1">
                                          <v-list-item-title class="text-left">
                                            Select All
                                          </v-list-item-title>
                                        </v-flex>
                                      </v-row>
                                    </div>
                                    <template
                                      v-for="(item, i) in spendingColumn"
                                    >
                                      <v-divider
                                        v-if="!item"
                                        :key="`divider-${i}`"
                                      ></v-divider>

                                      <v-list-item
                                        v-else
                                        :key="`item-${i}`"
                                        :value="item"
                                        class="text-left"
                                        style="max-height: 48px !important"
                                        active-class="primary--text text--accent-4"
                                      >
                                        <template v-slot:default="{ active }">
                                          <v-list-item-content
                                            style="max-width: 20px !important"
                                          >
                                            <!-- <v-checkbox
                                              :input-value="active"
                                              :true-value="item"
                                              color="primary accent-4"
                                              @click="toggle"
                                            ></v-checkbox> -->
                                          </v-list-item-content>

                                          <v-list-item-action
                                            style="width: 100%"
                                          >
                                            <v-flex xs12>
                                              <v-row>
                                                <v-flex xs2>
                                                  <v-icon
                                                    color="primary accent-4"
                                                    v-if="active"
                                                  >
                                                    check_box
                                                  </v-icon>
                                                  <v-icon
                                                    v-else
                                                    color="primary accent-4"
                                                  >
                                                    check_box_outline_blank
                                                  </v-icon>
                                                </v-flex>
                                                <v-flex xs8 class="pt-1">
                                                  <v-list-item-title
                                                    class="text-left"
                                                    v-text="item"
                                                  >
                                                  </v-list-item-title>
                                                </v-flex>
                                              </v-row>
                                            </v-flex>
                                          </v-list-item-action>
                                        </template>
                                      </v-list-item>
                                    </template>
                                  </VuePerfectScrollbar>
                                </v-list-item-group>
                              </v-menu>
                              <!-- table IO by taxonomy -->
                              <v-col sm="12" class="pt-1 pb-0">
                                <template>
                                  <v-simple-table
                                    fixed-header
                                    class="table-taxonomy nav-table"
                                  >
                                    <template v-slot:default>
                                      <VuePerfectScrollbar
                                        class="drawer-menu--scroll"
                                        :settings="scrollSettings"
                                      >
                                        <thead>
                                          <tr class="primary">
                                            <th
                                              class="pl-2 sticky-header1_"
                                              style="
                                                padding: 0px 15px !important;
                                              "
                                            >
                                              <label
                                                class="form-checkbox"
                                                style="margin-left: 27%"
                                              >
                                                <input
                                                  class="checkbox-approval"
                                                  type="checkbox"
                                                  v-model="item.selectAllIO"
                                                  @click="selectIO(item)"
                                                  style="margin-left: 27%"
                                                />
                                                <span class="checkbox-custom">
                                                </span>
                                              </label>
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                              "
                                              class="
                                                f-14
                                                white--text
                                                sticky-header2_
                                              "
                                            >
                                              IO Number
                                              <filter-column
                                                field="io_number"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'io_number',
                                                    index
                                                  )
                                                "
                                                :isCode="true"
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Code')
                                              "
                                              class="f-14 white--text"
                                              :class="
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                                  ? 'sticky-header3_'
                                                  : 'sticky-header2_'
                                              "
                                            >
                                              Code
                                              <filter-column
                                                field="code"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('code', index)
                                                "
                                                @filterItem="searchCln"
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Entity')
                                              "
                                              class="f-14 white--text"
                                            >
                                              Entity
                                              <filter-column
                                                field="brand.entity.name"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'brand.entity.name',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Brand')
                                              "
                                              class="f-14 white--text"
                                            >
                                              Brand
                                              <filter-column
                                                field="brand.name"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'brand.name',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('House')
                                              "
                                              class="f-14 white--text"
                                            >
                                              House
                                              <filter-column
                                                field="brand.house.name"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'brand.house.name',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Department'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Department
                                              <filter-column
                                                field="department"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'department',
                                                    index
                                                  )
                                                "
                                                @filterItem="searchCln"
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Category'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Category
                                              <filter-column
                                                field="category"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('category', index)
                                                "
                                                @filterItem="searchCln"
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Product Hierarchy'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Product Hierarchy
                                              <filter-column
                                                field="product.name"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'product.name',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Budget Owner'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Budget Owner
                                              <filter-column
                                                field="budgetOwner.desc"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'budgetOwner.desc',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('PIC')
                                              "
                                              class="f-14 white--text"
                                            >
                                              PIC
                                              <filter-column
                                                field="pic"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('pic', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Center Description'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Cost Center Description
                                              <filter-column
                                                field="taxonomy.costCenter.desc"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.costCenter.desc',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Center'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Cost Center
                                              <filter-column
                                                field="taxonomy.costCenter.code"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.costCenter.code',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Element (GL Protein)'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Cost Element (GL Protein)
                                              <filter-column
                                                field="taxonomy.costElement.code"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.costElement.code',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Element (GL Protein) Desc'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Cost Element (GL Protein) Desc
                                              <filter-column
                                                field="taxonomy.costElement.desc"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.costElement.desc',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Material Group'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Material Group
                                              <filter-column
                                                field="taxonomy.mat_group"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.mat_group',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Nature Activity'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Nature Activity
                                              <filter-column
                                                field="taxonomy.costCenter.costNature.nature_activity"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.costCenter.costNature.nature_activity',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Category'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Category
                                              <filter-column
                                                field="taxonomy.costCenter.costNature.category"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.costCenter.costNature.category',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Pillars')
                                              "
                                              class="f-14 white--text"
                                            >
                                              Pillars
                                              <filter-column
                                                field="pillars"
                                                @sortAsc="getAscSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('pillars', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Method')
                                              "
                                              class="f-14 white--text"
                                            >
                                              Method
                                              <filter-column
                                                field="method"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('method', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Campaign'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Campaign
                                              <filter-column
                                                field="campaign"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('campaign', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'BPC Line'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              BPC Line
                                              <filter-column
                                                field="taxonomy.bpc"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'taxonomy.bpc',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Start')
                                              "
                                              class="f-14 white--text"
                                            >
                                              Start
                                              <filter-column
                                                field="start"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'dateStart',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('End')
                                              "
                                              class="f-14 white--text"
                                            >
                                              End
                                              <filter-column
                                                field="end"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('dateEnd', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Activity Description'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Activity Description
                                              <filter-column
                                                field="activity_desc"
                                                @sortAsc="getAscSort"
                                                :indexItem="index"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'activity_desc',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <template
                                              v-for="(month, i) in months"
                                            >
                                              <th
                                                v-if="
                                                  columnActive.includes(
                                                    month
                                                  ) && i < 12
                                                "
                                                :key="i"
                                                class="f-14 white--text"
                                              >
                                                {{ month }}
                                                <filter-column
                                                  :field="'result.' + month"
                                                  :columnType="true"
                                                  @sortAsc="getNestedSort"
                                                  :indexItem="index"
                                                  @searchColumn="searchCln"
                                                  :listFilter="
                                                    getFiltered(
                                                      'result.' + month,
                                                      index
                                                    )
                                                  "
                                                />
                                              </th>
                                            </template>
                                            <th
                                              v-if="columnActive.includes('Q1')"
                                              class="f-14 white--text"
                                            >
                                              Q1
                                              <filter-column
                                                field="result.Q1"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'result.Q1',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="columnActive.includes('Q2')"
                                              class="f-14 white--text"
                                            >
                                              Q2
                                              <filter-column
                                                field="result.Q2"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'result.Q2',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="columnActive.includes('Q3')"
                                              class="f-14 white--text"
                                            >
                                              Q3
                                              <filter-column
                                                field="result.Q3"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'result.Q3',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="columnActive.includes('Q4')"
                                              class="f-14 white--text"
                                            >
                                              Q4
                                              <filter-column
                                                field="result.Q4"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'result.Q4',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Full Year IO'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Full Year IO
                                              <filter-column
                                                field="result.Full Year IO"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'result.Full Year IO',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="columnActive.includes('PO')"
                                              class="f-14 white--text"
                                            >
                                              PO
                                              <filter-column
                                                field="po"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('po', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes('Non-PO')
                                              "
                                              class="f-14 white--text"
                                            >
                                              Non-PO
                                              <filter-column
                                                field="non_po"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('non_po', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining IO'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Remaining IO
                                              <filter-column
                                                field="remainingIO"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'remainingIO',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="columnActive.includes('GR')"
                                              class="f-14 white--text"
                                            >
                                              GR
                                              <filter-column
                                                field="gr"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered('gr', index)
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Actual Non-PO'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Actual Non-PO
                                              <filter-column
                                                field="actualNonPO"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'actualNonPO',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining PO'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Remaining PO
                                              <filter-column
                                                field="remainingPO"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'remainingPO',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <th
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining Non-PO'
                                                )
                                              "
                                              class="f-14 white--text"
                                            >
                                              Remaining Non-PO
                                              <filter-column
                                                field="remainingNonPO"
                                                @sortAsc="getNestedSort"
                                                :indexItem="index"
                                                :columnType="true"
                                                @searchColumn="searchCln"
                                                :listFilter="
                                                  getFiltered(
                                                    'remainingNonPO',
                                                    index
                                                  )
                                                "
                                              />
                                            </th>
                                            <!-- <th class="f-14 white--text">
                                              Status
                                            </th> -->
                                            <th class="f-14 white--text">
                                              Details
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody v-if="item.dataIO.length > 0">
                                          <tr
                                            v-for="io in item.dataIO"
                                            :key="io.number"
                                            :class="
                                              bgStatusActive(
                                                io.notes,
                                                io.isSearch
                                              )
                                            "
                                          >
                                            <td
                                              class="sticky-body1_ pa-0"
                                              :class="
                                                bgStatusActive(
                                                  io.notes,
                                                  io.isSearch
                                                )
                                              "
                                            >
                                              <v-layout align-center>
                                                <label class="form-checkbox">
                                                  <input
                                                    type="checkbox"
                                                    class="checkbox-approval"
                                                    :value="io.id"
                                                    v-model="item.IOselected"
                                                  />
                                                  <span class="checkbox-custom">
                                                  </span>
                                                </label>
                                                <!-- <v-checkbox
                                                  :value="item.id"
                                                  v-model="selected"
                                                >
                                                </v-checkbox> -->
                                              </v-layout>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                              "
                                              class="sticky-body2_ pa-0"
                                              :class="
                                                bgStatusActive(
                                                  io.notes,
                                                  io.isSearch
                                                )
                                              "
                                            >
                                              <div>
                                                {{
                                                  io.io_number
                                                    ? io.io_number
                                                    : '-'
                                                }}
                                              </div>
                                            </td>
                                            <td
                                              class="pa-0"
                                              :class="[
                                                bgStatusActive(
                                                  io.notes,
                                                  io.isSearch
                                                ),
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                                  ? 'sticky-body3_'
                                                  : 'sticky-body2_'
                                              ]"
                                              v-if="
                                                columnActive.includes('Code')
                                              "
                                              @click="goTo(val)"
                                            >
                                              <div>
                                                {{ io ? io.code : '-' }}
                                              </div>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Entity')
                                              "
                                            >
                                              <span v-if="io.brand">
                                                {{
                                                  io.brand.entity
                                                    ? io.brand.entity.name
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>-</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Brand')
                                              "
                                            >
                                              <span v-if="io.brand">
                                                {{
                                                  io.brand ? io.brand.name : '-'
                                                }}
                                              </span>
                                              <span v-else>-</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('House')
                                              "
                                              class="text-capitalize"
                                            >
                                              <span v-if="io.brand">
                                                {{
                                                  io.brand.house
                                                    ? io.brand.house.name
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>-</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Department'
                                                )
                                              "
                                              class="text-capitalize"
                                            >
                                              <span v-if="io.department">
                                                {{
                                                  io.department
                                                    ? io.department || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>-</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Category'
                                                )
                                              "
                                              class="text-capitalize"
                                            >
                                              <span v-if="io.category">
                                                {{
                                                  io.category
                                                    ? io.category || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>-</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Product Hierarchy'
                                                )
                                              "
                                            >
                                              {{
                                                io.product
                                                  ? io.product.name
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Budget Owner'
                                                )
                                              "
                                            >
                                              {{
                                                io.budgetOwner
                                                  ? io.budgetOwner.desc
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('PIC')
                                              "
                                              class="text-capitalize"
                                            >
                                              {{ io ? io.pic : '-' }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Center Description'
                                                )
                                              "
                                              class="text-capitalize"
                                            >
                                              <span v-if="io.taxonomy">
                                                {{
                                                  io.taxonomy.costCenter
                                                    ? io.taxonomy.costCenter
                                                        .desc || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>{{ '-' }}</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Center'
                                                )
                                              "
                                            >
                                              <span v-if="io.taxonomy">
                                                {{
                                                  io.taxonomy.costCenter
                                                    ? io.taxonomy.costCenter
                                                        .code || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>{{ '-' }}</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Element (GL Protein)'
                                                )
                                              "
                                            >
                                              <span v-if="io.taxonomy">
                                                {{
                                                  io.taxonomy.costElement
                                                    ? io.taxonomy.costElement
                                                        .code || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>{{ '-' }}</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Element (GL Protein) Desc'
                                                )
                                              "
                                            >
                                              <span v-if="io.taxonomy">
                                                {{
                                                  io.taxonomy.costElement
                                                    ? io.taxonomy.costElement
                                                        .desc || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>{{ '-' }}</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Material Group'
                                                )
                                              "
                                            >
                                              {{
                                                io.taxonomy
                                                  ? io.taxonomy.mat_group || '-'
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Nature Activity'
                                                )
                                              "
                                            >
                                              <span v-if="io.taxonomy">
                                                {{
                                                  io.taxonomy.costCenter
                                                    ? io.taxonomy.costCenter
                                                        .costNature
                                                        .nature_activity || '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>{{ '-' }}</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Category'
                                                )
                                              "
                                              class="text-capitalize"
                                            >
                                              <span v-if="io.taxonomy">
                                                {{
                                                  io.taxonomy.costCenter
                                                    ? io.taxonomy.costCenter
                                                        .costNature.category ||
                                                      '-'
                                                    : '-'
                                                }}
                                              </span>
                                              <span v-else>{{ '-' }}</span>
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Pillars')
                                              "
                                              class="text-capitalize"
                                            >
                                              {{ io ? io.pillars : '-' }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Method')
                                              "
                                              class="text-capitalize"
                                            >
                                              {{ io ? io.method : '-' }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Campaign'
                                                )
                                              "
                                            >
                                              {{ io ? io.campaign : '-' }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'BPC Line'
                                                )
                                              "
                                            >
                                              {{
                                                io.taxonomy
                                                  ? io.taxonomy.bpc || '-'
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Start')
                                              "
                                            >
                                              {{
                                                io.dateStart
                                                  ? io.dateStart
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('End')
                                              "
                                            >
                                              {{
                                                io.dateEnd ? io.dateEnd : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Activity Description'
                                                )
                                              "
                                            >
                                              {{
                                                io.activity_desc
                                                  ? io.activity_desc
                                                  : '-'
                                              }}
                                            </td>
                                            <template
                                              v-for="amount in io.amount"
                                            >
                                              <td
                                                v-if="checkColumnActive(amount)"
                                                :key="amount.month"
                                                class="text-right"
                                              >
                                                {{
                                                  amount.value
                                                    ? idr(amount.value)
                                                    : '-'
                                                }}
                                              </td>
                                            </template>
                                            <td
                                              v-if="columnActive.includes('PO')"
                                              class="text-right"
                                            >
                                              {{ io.po ? idr(io.po) : '-' }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Non-PO')
                                              "
                                              class="text-right"
                                            >
                                              {{
                                                io.non_po ? idr(io.non_po) : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining IO'
                                                )
                                              "
                                              class="text-right"
                                            >
                                              {{
                                                io.remainingIO
                                                  ? idr(io.remainingIO)
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="columnActive.includes('GR')"
                                              class="text-right"
                                            >
                                              {{ io.gr ? idr(io.gr) : '-' }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Actual Non-PO'
                                                )
                                              "
                                              class="text-right"
                                            >
                                              {{
                                                io.actualNonPo
                                                  ? idr(io.actualNonPo)
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining PO'
                                                )
                                              "
                                              class="text-right"
                                            >
                                              {{
                                                io.remainingPO
                                                  ? idr(io.remainingPO)
                                                  : '-'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining Non-PO'
                                                )
                                              "
                                              class="text-right"
                                            >
                                              {{
                                                io.remainingNonPO
                                                  ? idr(io.remainingNonPO)
                                                  : '-'
                                              }}
                                            </td>

                                            <td class="text-center">
                                              <v-btn
                                                x-small
                                                class="ma-2"
                                                text
                                                icon
                                                color="primary"
                                                @click="noteModal(io)"
                                              >
                                                <v-icon
                                                  x-small
                                                  color="primary"
                                                  class="bg-info"
                                                >
                                                  info
                                                </v-icon>
                                              </v-btn>
                                            </td>
                                          </tr>
                                          <tr class="bgTotal">
                                            <td
                                              class="
                                                sticky-body1_
                                                border-r-0
                                                sticky-amount
                                              "
                                              style="z-index: 2 !important"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                              "
                                              class="
                                                sticky-body2_
                                                border-x-0
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                              style="z-index: 2 !important"
                                              :style="
                                                columnActive.includes('Code')
                                                  ? ''
                                                  : 'border-right: 1px solid #0000001f !important;'
                                              "
                                            >
                                              {{
                                                columnActive.includes('Code')
                                                  ? ''
                                                  : 'TOTAL'
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Code')
                                              "
                                              class="
                                                font-weight-bold
                                                text-right
                                                border-x-0
                                                sticky-amount
                                              "
                                              style="z-index: 2 !important"
                                              :style="
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                                  ? 'border-right: 1px solid #0000001f !important;'
                                                  : ''
                                              "
                                              :class="
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                                  ? 'sticky-body3_'
                                                  : ''
                                              "
                                            >
                                              {{
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                                  ? 'TOTAL'
                                                  : ''
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Entity')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('Brand')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('House')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Department'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Category'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Product Hierarchy'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Budget Owner'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('PIC')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Center Description'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Center'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Element (GL Protein)'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Cost Element (GL Protein) Desc'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Material Group'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Nature Activity'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Category'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('Pillars')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('Method')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Campaign'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'BPC Line'
                                                )
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('Start')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes('End')
                                              "
                                              class="border-x-0 sticky-amount"
                                            ></td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Activity Description'
                                                )
                                              "
                                              class="
                                                border-x-0
                                                text-right
                                                font-weight-bold
                                                sticky-amount
                                              "
                                            >
                                              {{
                                                columnActive.includes(
                                                  'IO Number'
                                                )
                                                  ? ''
                                                  : 'TOTAL'
                                              }}
                                            </td>
                                            <template
                                              v-for="month in formattedMonths"
                                            >
                                              <td
                                                class="
                                                  font-weight-bold
                                                  text-right
                                                  sticky-amount
                                                "
                                                v-if="
                                                  columnActive.includes(
                                                    month.text
                                                  )
                                                "
                                                :key="month.text"
                                              >
                                                {{
                                                  totalAmount(item, month.value)
                                                }}
                                              </td>
                                            </template>
                                            <td
                                              v-if="columnActive.includes('PO')"
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{ totalAmountFor(item, 'po') }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes('Non-PO')
                                              "
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{
                                                totalAmountFor(item, 'non_po')
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining IO'
                                                )
                                              "
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{
                                                totalAmountFor(
                                                  item,
                                                  'remainingIO'
                                                )
                                              }}
                                            </td>
                                            <td
                                              v-if="columnActive.includes('GR')"
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{ totalAmountFor(item, 'gr') }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Actual Non-PO'
                                                )
                                              "
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{
                                                totalAmountFor(
                                                  item,
                                                  'actualNonPo'
                                                )
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining PO'
                                                )
                                              "
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{
                                                totalAmountFor(
                                                  item,
                                                  'remainingPO'
                                                )
                                              }}
                                            </td>
                                            <td
                                              v-if="
                                                columnActive.includes(
                                                  'Remaining Non-PO'
                                                )
                                              "
                                              class="
                                                font-weight-bold
                                                text-right
                                                sticky-amount
                                              "
                                            >
                                              {{
                                                totalAmountFor(
                                                  item,
                                                  'remainingNonPO'
                                                )
                                              }}
                                            </td>
                                            <td class="sticky-amount"></td>
                                          </tr>
                                        </tbody>
                                        <tbody v-else>
                                          <tr>
                                            <td
                                              colspan="45"
                                              class="text-center pt-2"
                                            >
                                              <span>No Data Displayed</span>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </VuePerfectScrollbar>
                                    </template>
                                  </v-simple-table>
                                </template>
                              </v-col>
                              <v-flex xs12 class="text-right px-2">
                                <v-btn
                                  class="ma-2 white--text"
                                  color="#bd1e19"
                                  :disabled="item.IOselected.length < 1"
                                  @click="confirmReject(item)"
                                >
                                  Reject
                                </v-btn>
                                <v-btn
                                  primary
                                  class="primary ma-2"
                                  :disabled="
                                    item.IOselected.length !==
                                      item.dataIO.length
                                  "
                                  @click="confirmApprove(item, index)"
                                >
                                  Approve
                                </v-btn>
                              </v-flex>
                            </v-row>
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-layout>
    <v-dialog v-model="showDialog" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <span>Reject Spending</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <label class="darkblue--text">Reason</label>
                <v-textarea
                  label="Type your reason here"
                  single-line
                  outlined
                  v-model="reason"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#bd1e19" dark @click="showDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" :disabled="!reason" @click="reject()">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog reject notes by IO -->
    <modal-rejectIO
      :itemsReview="itemsReview"
      :items="items"
      :isModal="isModal"
      :downloadFile="downloadFile"
      :reviewData="reviewData"
      :scrollSettingsNotes="scrollSettingsNotes"
      @closeModal="closeModalNotes"
    />
    <v-dialog v-model="rejectNotes" max-width="800px">
      <v-card>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="submitNotes" class="pa-0">
            <v-card-title class="primary white--text">
              <span>Notes</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="pa-0">
                    <span
                      class="
                        pl-2
                        pt-1
                        font-weight-medium
                        subtitle-1
                        darkblue--text
                      "
                      >Rejected Reason</span
                    >
                    <v-textarea
                      label="Type your reason here"
                      single-line
                      class="mt-2"
                      outlined
                      v-model="reason"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="pr-5 pb-5">
              <v-spacer></v-spacer>
              <v-btn color="#bd1e19" dark @click="rejectNotes = false">
                Cancel
              </v-btn>
              <v-btn color="primary" type="submit"> Submit </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="showFilterDialog" persistent :max-width="filterWdh">
      <v-card class="rounded-12">
        <v-card-title
          class="primary white--text fs-16 lh-20 font-weight-bold py-4 px-6"
        >
          <img
            src="@/assets/images/icon/filter.png"
            width="20px"
            class="mr-3"
          />
          <span class="pa-0">Spending Approval Filter</span>
          <v-spacer></v-spacer>
          <v-icon
            @click="showFilterDialog = false"
            color="white"
            class="fs-18"
            style="font-size: 20px !important; margin-right: -4px !important"
          >
            close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-0 px-3 border-b-1">
          <v-container class="py-0 form-filter">
            <v-row>
              <v-col class="pt-4">
                <h4 class="primary--text lh-17 mb-2">
                  Filter By
                </h4>
                <div
                  v-if="showFilterDivision"
                  :class="
                    filter === 'divisi'
                      ? 'menuActive--text font-weight-600'
                      : ''
                  "
                  class="pt-3 pb-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('divisi')"
                >
                  <span class="fs-12">Division</span>
                </div>
                <div
                  v-if="showFilterHouse"
                  :class="
                    filter === 'house' ? 'menuActive--text font-weight-600' : ''
                  "
                  class="py-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('house')"
                >
                  <span class="fs-12">House</span>
                </div>
                <div
                  v-if="showFilterDept"
                  :class="
                    filter === 'department'
                      ? 'menuActive--text font-weight-600'
                      : ''
                  "
                  class="py-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('department')"
                >
                  <span class="fs-12">Department</span>
                </div>
                <div
                  :class="
                    filter === 'budgetOwner'
                      ? 'menuActive--text font-weight-600'
                      : ''
                  "
                  class="py-2 font-weight-500"
                  style="cursor:pointer;"
                  @click="changeFilter('budgetOwner')"
                >
                  <span class="fs-12">Budget Owner</span>
                </div>
              </v-col>
              <v-col
                v-if="divisionList.length > 0 && showFilterDivision"
                class="pt-4 border-l-1"
              >
                <h4 class="primary--text lh-17 mb-2">
                  Division
                </h4>
                <VuePerfectScrollbar
                  class="drawer-menu--scroll"
                  :settings="scrollSettings"
                >
                  <div class="py-3" style="margin-left: -5px;">
                    <v-checkbox
                      v-for="(division, index) in divisionList"
                      :key="'filter' + index"
                      v-model="divisionObj"
                      :label="division.name"
                      :value="division.id"
                      color="menuActive"
                    >
                    </v-checkbox>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
              <v-col
                class="pt-4 border-l-1"
                v-if="houseList.length > 0 && showFilterHouse"
              >
                <h4 class="primary--text lh-17 mb-2">
                  House
                </h4>
                <div class="py-3" style="margin-left: -5px;">
                  <v-checkbox
                    v-for="(house, index) in houseList"
                    :key="'filter' + index"
                    v-model="houseObj"
                    :label="house.name"
                    :value="house.id"
                    color="menuActive"
                  >
                  </v-checkbox>
                </div>
              </v-col>
              <v-col
                class="pt-4 border-l-1"
                v-if="deptList.length > 0 && showFilterDept"
              >
                <h4 class="primary--text lh-17 mb-2">
                  Department
                </h4>
                <VuePerfectScrollbar
                  class="drawer-menu--scroll"
                  :settings="scrollSettings"
                >
                  <div class="py-3" style="margin-left: -5px;">
                    <v-checkbox
                      v-for="(dept, index) in deptList"
                      :key="'filter' + index"
                      v-model="deptObj"
                      :label="dept.name"
                      :value="dept.id"
                      color="menuActive"
                    >
                    </v-checkbox>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
              <v-col class="pt-4 border-l-1" v-if="boList.length > 0">
                <h4 class="primary--text lh-17 mb-2">
                  Budget Owner
                </h4>
                <VuePerfectScrollbar
                  class="drawer-menu--scroll"
                  :settings="scrollSettings"
                >
                  <div class="py-3" style="margin-left: -5px;">
                    <v-checkbox
                      v-for="(bo, index) in boList"
                      :key="'filter' + index"
                      v-model="boObj"
                      :label="bo.name"
                      :value="bo.id"
                      color="menuActive"
                    >
                    </v-checkbox>
                  </div>
                </VuePerfectScrollbar>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="py-3 px-6">
          <v-btn
            color="primary"
            dark
            class="rounded-6 text-capitalize px-4"
            @click="resetFilter"
          >
            Reset Filter
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="rounded-6 text-capitalize px-4"
            dark
            @click="setFilter()"
          >
            View Data
          </v-btn>
          <v-btn color="menuActive" class="rounded-6 text-capitalize" dark>
            Download
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2';
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import CardAmount from '../../../components/cardAmount';
import summaryAmount from '../../../components/summaryAmount';
import filterColumn from '../../../components/filterColumn';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import { arrayToParam } from '@/utils/helpers';
import { mapGetters, mapState } from 'vuex';
import modalRejectIO from '../../../components/approval/modalRejectIO';
import tableDiv from '../../../components/approval/tableDiv';
import advanceFilter from '../../../components/advanceFilter/checkboxFilter';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'card-amount': CardAmount,
    'summary-amount': summaryAmount,
    VuePerfectScrollbar,
    'filter-column': filterColumn,
    'modal-rejectIO': modalRejectIO,
    'table-div': tableDiv,
    'dialog-advance-filter': advanceFilter
  },
  props: ['yearIo', 'io', 'divisiIo', 'houseIo', 'deptIo', 'boIo'],
  mixins: [LoginAsMixin],
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsNotes: {
        maxScrollbarLength: 150
      },
      tab: null,
      isModal: false,
      loading: true,
      progressDialogLoading: true,
      search: '',
      altLabels: true,
      check: true,
      breadcrumbs: [
        {
          text: 'SPENDING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'APPROVAL & VERIFICATION',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
        'Q1',
        'Q2',
        'Q3',
        'Q4',
        'Full Year IO'
      ],
      singleSelect: false,
      headersBO: [
        {
          text: 'Budget Owner Name',
          value: 'budgetOwnerName',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Total Budget',
          value: 'totalBudget',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Total Spending',
          value: 'totalSpending',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Total Remaining',
          value: 'totalRemaining',
          sortable: false,
          align: 'center'
        },
        {
          text: 'Notes',
          value: 'notes',
          sortable: false,
          align: 'center'
        }
      ],
      showDialog: false,
      selected: [],
      selectedAllColumn: false,
      selectAll: false,
      selectAllHouse: false,
      selectAllDept: false,
      selectAllBO: false,
      houseSelected: [],
      deptSelected: [],
      BOselected: [],
      items: [],
      itemsReview: {
        result: [],
        notes: ''
      },
      reviewData: {},
      year: new Date(),
      reason: '',
      panel: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      filter: '',
      filters: [],
      user: {},
      showDept: false,
      showBO: false,
      showIO: false,
      showHouse: false,
      budgetOwners: [],
      reasonBO: '',
      modalReject: '',
      rejectNotes: false,
      budgetOwnerId: null,
      houseId: null,
      divisiId: null,
      deptId: null,
      headers: [
        {
          text: 'Dessert (100g serving)',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' }
      ],
      profile_id: 0,
      filterName: '',
      tabItems: [],
      indexFilter: 0,
      columnActive: [],
      spendingColumn: [
        'IO Number',
        'Code',
        'Entity',
        'Brand',
        'House',
        'Department',
        'Category',
        'Product Hierarchy',
        'Budget Owner',
        'PIC',
        'Cost Center Description',
        'Cost Center',
        'Cost Element (GL Protein)',
        'Cost Element (GL Protein) Desc',
        'Material Group',
        'Nature Activity',
        'Category',
        'Pillars',
        'Method',
        'Campaign',
        'BPC Line',
        'Start',
        'End',
        'Activity Description',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
        'Q1',
        'Q2',
        'Q3',
        'Q4',
        'Full Year IO',
        'PO',
        'Non-PO',
        'Remaining IO',
        'GR',
        'Actual Non-PO',
        'Remaining PO',
        'Remaining Non-PO'
      ],
      summaryAmount: {},
      showFilterDialog: false,
      panelSummary: [],
      divisionObj: [],
      houseObj: [],
      deptObj: [],
      boObj: [],
      divisionList: [],
      houseList: [],
      deptList: [],
      boList: [],
      showFilterDivision: false,
      showFilterHouse: false,
      showFilterDept: false,
      showFilterBo: false,
      filterWdh: '30%'
    };
  },
  computed: {
    ...mapState('auth', ['userRole']),
    ...mapGetters('auth', ['userMapping']),
    ioSearch() {
      return this.io;
    },
    formattedMonths() {
      return this.months.map((item, index) => ({
        text: item,
        value: index === 16 ? 'Total' : item.toLowerCase()
      }));
    },
    division_ids() {
      const { division } = this.defaultParams;
      return [...division, ...this.divisionObj];
    },
    house_ids() {
      const { house } = this.defaultParams;
      return [...house, ...this.houseObj];
    },
    dept_ids() {
      const { dept } = this.defaultParams;
      return [...dept, ...this.deptObj];
    },
    bo_ids() {
      const { bo } = this.defaultParams;
      return [...bo, ...this.boObj];
    },
    division_ids_param() {
      return arrayToParam(this.division_ids);
    },
    house_ids_param() {
      return arrayToParam(this.house_ids);
    },
    dept_ids_param() {
      return arrayToParam(this.dept_ids);
    },
    bo_ids_param() {
      return arrayToParam(this.bo_ids);
    },
    isFilteringDivision() {
      return this.divisionNames.length > 0;
    },
    isFilteringHouse() {
      return this.houseNames.length > 0;
    },
    isFilteringDept() {
      return this.deptNames.length > 0;
    },
    isFilteringBO() {
      return this.boNames.length > 0;
    },
    divisionNames() {
      return this.divisionObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    houseNames() {
      return this.houseObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    deptNames() {
      return this.deptObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    boNames() {
      return this.boObj
        .map(item => item.name)
        .filter(Boolean)
        .join(' / ');
    },
    filter_by() {
      let filterDivision = this.showFilterDivision
        ? `${this.isFilteringDivision ? this.divisionNames : 'All Division'}`
        : '';
      let filterHouse = this.showFilterHouse
        ? `/ ${this.isFilteringHouse ? this.houseNames : 'All House'}`
        : '';
      let filterDept = this.showFilterDept
        ? `/ ${this.isFilteringDept ? this.deptNames : 'All Department'}`
        : '';
      let filterBO = this.showFilterBo
        ? `/ ${this.isFilteringBO ? this.boNames : 'All BO'}`
        : '';
      const year = moment(this.year).format('YYYY');
      const separator = this.showFilterDivision ? '/' : '';
      if (this.divisionObj.length === this.divisionList.length) {
        filterDivision = 'All Division';
      }
      if (this.houseObj.length === this.houseList.length) {
        filterHouse = 'All House';
      }
      if (this.deptObj.length === this.deptList.length) {
        filterDept = 'All Department';
      }
      if (this.boObj.length === this.boList.length) {
        filterBO = 'All BO';
      }
      return `${year} ${separator} ${filterDivision} ${filterHouse} ${filterDept} ${filterBO}`;
    },
    defaultParams() {
      const { mapping } = this.userRole || {};
      const { profile_id, divisi_id, house_id, dept_id } = mapping || {};

      const divisionParams = [divisi_id];
      const houseParams = [house_id];
      const deptParams = [dept_id];
      const boParams = [profile_id];

      let division = [];
      let house = [];
      let dept = [];
      let bo = [];

      if (this.isLoggedInAsDirector) {
        division = divisionParams;
      }

      if (this.isLoggedInAsBrandHead) {
        division = divisionParams;
        house = houseParams;
      }

      if (this.isLoggedInAsDeptHead) {
        division = divisionParams;
        house = houseParams;
        dept = deptParams;
      }

      if (this.isLoggedInAsBO) {
        division = divisionParams;
        house = houseParams;
        dept = deptParams;
        bo = boParams;
      }
      return {
        division,
        house,
        dept,
        bo
      };
    }
  },
  watch: {
    ioSearch() {
      this.getDataSearch();
    },
    yearIo() {
      this.year = new Date(this.yearIo, 0);
      this.setFilter();
    },
    tab(val) {
      this.filter = this.filters[val].value;
      this.indexFilter = val;
      if (this.filters[val].name === 'Budget Owner') {
        this.filterName = 'Spending by Taxonomy';
      } else {
        if (this.isLoggedInAsHN) {
          switch (this.filters[val + 1].value) {
            case 'house':
              this.filterName = 'Department';
              break;
            case 'department':
              this.filterName = 'Category';
              break;
            case 'budgetOwner':
              this.filterName = 'Budget Owner';
              break;
          }
        } else {
          if (this.filters[val + 1].name === 'Budget Owner') {
            this.filterName = this.filters[val + 1].name;
          } else {
            this.filterName = this.filters[val + 1].value;
          }
        }
      }
    },
    columnActive(val) {
      localStorage.setItem('columnActiveApproval', val);
      if (val.length !== this.spendingColumn.length) {
        this.selectedAllColumn = false;
      } else {
        this.selectedAllColumn = true;
      }
    },
    divisionObj(val) {
      if (val.length !== 0) {
        this.filterWdh = this.wdhFilter('house');
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.resetHouse();
          this.resetDept();
          this.resetBO();
          this.getHouses();
        }, 900);
      }
    },
    async houseObj(val) {
      if (val.length !== 0) {
        this.filterWdh = this.wdhFilter('department');
        // clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        await this.resetDept();
        await this.resetBO();
        await this.getDept();
        // }, 900);
      }
    },
    deptObj(val) {
      this.boObj = [];
      if (val.length !== 0) {
        this.filterWdh = this.wdhFilter('budgetOwner');
        // clearTimeout(this.timeout);
        // this.timeout = setTimeout(() => {
        //   if (!this.initializing) {
        this.resetBO();
        //   }
        this.getBO();
        // }, 900);
      }
    }
  },
  async mounted() {
    let column = localStorage.getItem('columnActiveApproval');
    let arrColumn = null;
    if (column) {
      arrColumn = column.split(',');
    } else {
      arrColumn = this.spendingColumn;
    }
    if (this.spendingColumn !== arrColumn) {
      this.columnActive = arrColumn;
    } else {
      this.columnActive = this.spendingColumn;
    }
    this.filters = JSON.parse(localStorage.getItem('filters'));
    this.filter = this.filters[0].value;
    if (this.isLoggedInAsHN) {
      for (let i = 0; i < this.filters.length; i++) {
        switch (this.filters[i].name) {
          case 'House':
            this.filters[i].name = 'Department';
            break;
          case 'Department':
            this.filters[i].name = 'Category';
            break;
        }
      }
    } else if (this.isLoggedInAsFinance) {
      for (let i = 0; i < this.filters.length; i++) {
        switch (this.filters[i].name) {
          case 'House':
            this.filters[i].name = 'House/Dept';
            break;
          case 'Department':
            this.filters[i].name = 'Dept/Category';
            break;
        }
      }
    }
    this.user = JSON.parse(localStorage.getItem('user'));
    this.profile_id = localStorage.getItem('profile_id');
    this.year = this.yearIo ? new Date(this.yearIo, 0) : new Date();
    this.resetTab();
    await this.getSummaryAmount();
    await this.filterCheck();
    await this.fetchFilterData();
    this.filterGroup();
    // if (this.filters[0] === 'budgetOwner') {
    //   this.getData(this.year);
    // } else {
    //   this.getPendingGroup(this.year);
    //   this.getDivision();
    // }
    if (this.io) {
      this.indexFilter = 3;
      this.tab = 3;
      // this.setFilter({ name: 'Budget Owner', value: 'budgetOwner' }, 3);
      this.getDataSearch();
    }
  },
  methods: {
    closeModalNotes(val) {
      this.isModal = val;
    },
    async getDataSearch(params = {}) {
      this.indexFilter = 3;
      this.tab = 3;
      this.progressDialogLoading = true;
      this.items = [];
      // this.lastDivisionId = null;
      // this.lastHouseId = null;
      // this.lastDeptId = null;
      this.filterGroup();
      this.year = new Date(this.yearIo, 0);
      try {
        const divisionIds = Array(this.divisiIo.toString());
        let houseIds = Array(this.houseIo.toString());
        const departmentIds = Array(this.deptIo.toString());
        const budgetOwnerIds = Array(this.boIo.toString());
        const year = this.yearIo;
        const data = await this.$store.dispatch('spending/advanceFilter', {
          year,
          profileId: this.profile_id,
          divisionIds: divisionIds,
          houseIds: houseIds,
          departmentIds: departmentIds,
          budgetOwnerIds: budgetOwnerIds,
          type: 'approval',
          ...params
        });
        // const hasBO = budgetOwnerIds.length > 0;
        this.items = data.map(element => {
          const totalItem = {
            totalBudgetEur: element.totalBudgetEuro,
            totalBudget: element.totalBudget,
            remainingBudget: element.remaining,
            remainingEur: element.remainingEuro,
            spentEur: element.totalSpendingEuro,
            totalSpending: element.totalSpending
          };
          return {
            ...element,
            dataIO: [],
            IOselected: [],
            selectAllIO: false,
            house: [],
            houseSelected: [],
            selectAllHouse: false,
            dept: [],
            deptSelected: [],
            selectAllDept: false,
            budgetOwners: [],
            BOselected: [],
            selectAllBO: false,
            isInformation: false,
            isTracking: false,
            ioFull: [],
            showHouse: false,
            showDept: false,
            showBO: false,
            showIO: false,
            houseActive: 0,
            deptActive: 0,
            boActive: 0,
            adhoc: element.adhoc,
            status: element.status,
            ...totalItem
          };
        });
        let item = this.items;
        this.tabItems[this.indexFilter].data = item;
        this.progressDialogLoading = false;
      } catch (e) {
        this.progressDialogLoading = false;
      }
    },
    handleRefresh() {
      localStorage.setItem('columnActiveApproval', this.spendingColumn);
    },
    async openFilterDialog() {
      await this.filterCheck();
      this.showFilterDialog = true;
    },
    getSummaryAmount() {
      this.progressDialogLoading = true;
      let params = {
        profileId: localStorage.getItem('profile_id'),
        year: moment(this.year).format('YYYY'),
        type: 'approval'
      };
      return this.$store
        .dispatch('spending/summaryAmount', params)
        .then(data => {
          if (data.code === 200) {
            this.progressDialogLoading = false;
            this.summaryAmount = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.data.error, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_ren, 'error');
        });
    },
    totalAmount(item, month) {
      month = month === 'Total' ? 'full year io' : month;
      let amountTotal = item.dataIO.reduce((total, items) => {
        const value = +(
          items.amount.find(
            val => val.month.toLowerCase() === month.toLowerCase()
          ) || {}
        ).value;
        total += value;
        return total;
      }, 0);
      if (Number(amountTotal) === 0) {
        return '-';
      } else {
        return this.idr(Math.round(amountTotal));
      }
    },
    totalAmountFor(item, key) {
      let amountFor = item.dataIO.reduce((total, val) => {
        const value = +(val[key] || 0);
        total += value;
        return total;
      }, 0);
      if (Number(amountFor) === 0) {
        return '-';
      } else {
        return this.idr(Math.round(amountFor));
      }
    },
    async setFilter(item, index) {
      this.showFilterDialog = false;
      await this.getSummaryAmount();
      if (item) {
        if (!this.tabItems[index].data.length > 0) {
          this.progressDialogLoading = true;
          if (item.value === 'divisi') {
            this.divisionObj = [];
            this.deptObj = [];
            this.houseObj = [];
            this.boObj = [];
            this.fetchFilterData();
          }
          if (item.value === 'house') {
            this.deptObj = [];
            this.boObj = [];
            await this.getHouses();
            this.divisionObj = this.divisionList.map(element => element.id);
            if (this.isLoggedInAsFinance) {
              this.houseObj = this.houseList.map(element => element.id);
              this.deptObj = [];
            }
            if (this.isLoggedInAsDirector) {
              this.houseObj = this.houseList.map(element => element.id);
            }
            this.fetchFilterData();
          }
          if (item.value === 'department') {
            this.divisionObj = [];
            this.deptObj = [];
            this.boObj = [];
            await this.getHouses();
            if (this.isLoggedInAsFinance) {
              this.houseObj = this.houseList.map(element => element.id);
              this.divisionObj = this.divisionList.map(element => element.id);
              await this.getDept();
              this.deptObj = this.deptList.map(element => element.id);
            }
            if (this.isLoggedInAsDirector) {
              this.houseObj = this.houseList.map(element => element.id);
              await this.getDept();
              this.deptObj = this.deptList.map(element => element.id);
            }
            if (this.isLoggedInAsBrandHead) {
              await this.getDept();
              this.deptObj = this.deptList.map(element => element.id);
            }
            if (this.isLoggedInAsDeptHead) {
              this.reset();
            }
            this.fetchFilterData();
          }
          if (item.value === 'budgetOwner') {
            if (this.isLoggedInAsFinance || this.isLoggedInAsDirector) {
              this.divisionObj = this.divisionList.map(element => element.id);
              await this.getHouses();
              this.houseObj = this.houseList.map(element => element.id);
              await this.getDept();
              this.deptObj = this.deptList.map(element => element.id);
              await this.getBO();
              this.boObj = this.boList.map(element => element.id);
            }
            if (this.isLoggedInAsBrandHead) {
              await this.getDept();
              this.deptObj = this.deptList.map(element => element.id);
              await this.getBO();
              this.boObj = this.boList.map(element => element.id);
            }
            if (this.isLoggedInAsDeptHead) {
              await this.getBO();
              this.boObj = this.boList.map(element => element.id);
            }
            this.fetchFilterData();
          }
        }
        if (this.io && item.value === 'budgetOwner') {
          if (this.isLoggedInAsFinance || this.isLoggedInAsDirector) {
            this.divisionObj = this.divisionList.map(element => element.id);
            await this.getHouses();
            this.houseObj = this.houseList.map(element => element.id);
            await this.getDept();
            this.deptObj = this.deptList.map(element => element.id);
            await this.getBO();
            this.boObj = this.boList.map(element => element.id);
          }
          // if (this.isLoggedInAsDirector) {
          //   this.houseObj = this.houseList.map(element => element.id);
          //   this.deptObj = this.deptList.map(element => element.id);
          //   this.boObj = this.boList.map(element => element.id);
          // }
          if (this.isLoggedInAsBrandHead) {
            await this.getDept();
            this.deptObj = this.deptList.map(element => element.id);
            await this.getBO();
            this.boObj = this.boList.map(element => element.id);
          }
          if (this.isLoggedInAsDeptHead) {
            await this.getBO();
            this.boObj = this.boList.map(element => element.id);
          }
          // await this.getDept();
          // this.houseObj = this.houseList;
          // await this.getBO();
          // this.boObj = this.boList;
          // this.divisionObj = this.divisionList;
          // this.houseObj = this.houseList;
          this.tabItems[this.indexFilter].data = [];
          this.fetchFilterData();
        }
      } else {
        this.resetTab();
        if (this.divisionObj.length > 0) {
          this.getHouses();
        }
        if (this.houseObj.length > 0) {
          this.getDept();
        }
        if (this.deptObj.length > 0) {
          this.getBO();
        }
        this.setTab();
        await this.filterCheck();
        this.fetchFilterData();
      }
    },
    setTab(obj) {
      if (obj) {
        this.filter = obj.filter;
        this.filters = obj.filters;
      }
      let houseIds = obj ? obj.house_ids : this.house_ids;
      const deptNoHouse =
        this.isLoggedInAsDeptHead && !this.userMapping.house_id;
      if (deptNoHouse) {
        houseIds = obj ? obj.house_ids : this.houseList.map(item => item.id);
      }

      const hasDivision = obj
        ? obj.division_ids.length > 0
        : this.division_ids.length > 0;
      const hasHouse = houseIds.length > 0;
      const hasDepartment = obj
        ? obj.dept_ids.length > 0
        : this.dept_ids.length > 0;
      const hasBO = obj ? obj.bo_ids.length > 0 : this.bo_ids.length > 0;

      if (this.isLoggedInAsFinance || this.isLoggedInAsDirector) {
        if (hasDivision || !hasDivision) {
          this.tab = 0;
          this.filter = this.filters[this.tab].value;
        }
        if (hasDivision && hasHouse) {
          this.tab = 1;
          this.filter = this.filters[this.tab].value;
        }
        if (hasDivision && hasHouse && hasDepartment) {
          this.tab = 2;
          this.filter = this.filters[this.tab].value;
        }
        if (hasDivision && hasHouse && hasDepartment && hasBO) {
          this.tab = 3;
          this.filter = this.filters[this.tab].value;
        }
      } else if (this.isLoggedInAsBrandHead) {
        if (hasHouse || !hasHouse) {
          this.tab = 0;
          this.filter = this.filters[this.tab].value;
        }
        if (hasHouse && hasDepartment) {
          this.tab = 1;
          this.filter = this.filters[this.tab].value;
        }
        if (hasHouse && hasDepartment && hasBO) {
          this.tab = 2;
          this.filter = this.filters[this.tab].value;
        }
      } else if (this.isLoggedInAsDeptHead) {
        if (hasDepartment || !hasDepartment) {
          this.tab = 0;
          this.filter = 'divisi';
        }
        if (hasDepartment && hasBO) {
          this.tab = 1;
          this.filter = 'house';
        }
      }
    },
    async getParam(obj) {
      await this.fetchFilterData(obj);
    },
    async fetchFilterData(obj, params = {}) {
      this.progressDialogLoading = true;
      this.items = [];
      // this.lastDivisionId = null;
      // this.lastHouseId = null;
      // this.lastDeptId = null;

      try {
        const divisionIds = obj ? obj.divisionIds : this.division_ids;
        let houseIds = obj ? obj.houseIds : this.house_ids;
        const departmentIds = obj ? obj.departmentIds : this.dept_ids;
        const budgetOwnerIds = obj ? obj.budgetOwnerIds : this.bo_ids;
        const year = moment(this.year).format('YYYY');

        const deptNoHouse =
          this.isLoggedInAsDeptHead && !this.userMapping.house_id;

        if (deptNoHouse) {
          houseIds = obj ? obj.houseIds : this.houseList.map(item => item.id);
        }
        const data = await this.$store.dispatch('spending/advanceFilter', {
          year,
          profileId: this.profile_id,
          divisionIds: divisionIds,
          houseIds: houseIds,
          departmentIds: departmentIds,
          budgetOwnerIds: budgetOwnerIds,
          type: 'approval',
          ...params
        });
        // const hasBO = budgetOwnerIds.length > 0;
        this.items = data.map(item => {
          const totalItem = {
            totalBudgetEur: item.totalBudgetEuro,
            totalBudget: item.totalBudget,
            remainingBudget: item.remaining,
            remainingEur: item.remainingEuro,
            spentEur: item.totalSpendingEuro,
            totalSpending: item.totalSpending
          };
          return {
            ...item,
            dataIO: [],
            IOselected: [],
            selectAllIO: false,
            house: [],
            houseSelected: [],
            selectAllHouse: false,
            dept: [],
            deptSelected: [],
            selectAllDept: false,
            budgetOwners: [],
            BOselected: [],
            selectAllBO: false,
            isInformation: false,
            isTracking: false,
            ioFull: [],
            showHouse: false,
            showDept: false,
            showBO: false,
            showIO: false,
            houseActive: 0,
            deptActive: 0,
            boActive: 0,
            adhoc: item.adhoc,
            status: item.status,
            ...totalItem
          };
        });
        if (this.tabItems[this.indexFilter].data.length === 0) {
          let item = this.items;
          this.tabItems[this.indexFilter].data = item;
        }
        this.progressDialogLoading = false;
      } catch (e) {
        this.progressDialogLoading = false;
      }
    },
    getTable(item) {
      let data = '';
      if (item.filterBy === 'division') {
        data = 'house';
      } else if (item.filterBy === 'house') {
        data = 'dept';
      } else if (item.filterBy === 'department') {
        data = 'budgetOwners';
      } else if (item.filterBy === 'bo') {
        data = 'dataIO';
      }
      if (item[data].length === 0) {
        if (item.filterBy !== 'bo') {
          this.getDetailApproval({ item: item, itemParent: item });
        } else {
          this.getIO({ item: item, itemParent: item });
        }
      }
    },
    getDetailApproval(obj) {
      // getDetailApproval(item, itemParent) {
      this.progressDialogLoading = true;
      let date = new Date();
      if (!this.year) {
        this.year = moment(date).format('YYYY');
      }
      let divisiId = null;
      if (obj.item.filterBy === 'house') {
        if (this.isLoggedInAsFinance && this.filter === 'house') {
          if (this.divisionObj.length > 0) {
            divisiId = this.divisionObj;
          } else {
            divisiId = this.divisionList.map(val => {
              return val.id;
            });
          }
        } else if (this.isLoggedInAsFinance && this.filter === 'divisi') {
          divisiId = Array(obj.itemParent.id.toString());
        } else {
          divisiId = this.division_ids;
        }
      }
      let houseIds = null;
      if (obj.item.filterBy === 'department') {
        if (typeof obj.item.houseId === 'object') {
          houseIds = obj.item.houseId;
        } else {
          houseIds = Array(obj.item.houseId.toString());
        }
      }
      const params = {
        year: moment(this.year).format('YYYY'),
        profileId: this.profile_id,
        id: obj.item.id,
        houseIds: houseIds,
        filterBy: obj.item.filterBy,
        divisionIds: divisiId,
        type: 'approval'
      };
      this.$store
        .dispatch('spending/getDetailSpending', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.tabItems[this.indexFilter].data.map(val => {
              if (Number(val.id) === Number(obj.itemParent.id)) {
                if (obj.item.filterBy === 'division') {
                  val.house = data.data;
                  val.showDept = false;
                  val.showHouse = true;
                } else if (obj.item.filterBy === 'house') {
                  val.houseActive = Number(obj.item.id);
                  val.dept = data.data;
                  val.showDept = true;
                  val.showBO = false;
                  val.showIO = false;
                } else if (obj.item.filterBy === 'department') {
                  val.deptActive = Number(obj.item.id);
                  val.budgetOwners = data.data;
                  val.showBO = true;
                  val.showIO = false;
                }
              }
              return val;
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          if (err.response) {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          } else {
            Swal.fire('Failed!', 'Please try again', 'error');
          }
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getIO(obj) {
      // getIO(item, itemParent) {
      this.progressDialogLoading = true;
      this.loading = true;
      let date = new Date();
      if (!this.year) {
        this.year = moment(date).format('YYYY');
      }
      const params = {
        year: moment(this.year).format('YYYY'),
        profileId: this.profile_id,
        budgetCode: obj.item.budgetCode,
        type: 'approval',
        searched: this.io ? this.io : ''
      };
      this.$store
        .dispatch('spending/getIO', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.selectAll = false;
            this.tabItems[this.indexFilter].data.map(val => {
              if (Number(val.id) === Number(obj.itemParent.id)) {
                val.approval_status = data.data.progress_tracking;
                val.boActive = Number(obj.item.id);
                val.dataIO = data.data.result
                  ? data.data.result.map(items => {
                      var result = {};
                      // ubah array of object jadi object
                      for (var a = 0; a < items.amount.length; a++) {
                        result[items.amount[a].month] = Number(
                          items.amount[a].value
                        );
                      }
                      // handle taxo null
                      if (!items.taxonomy) {
                        items.taxonomy = {
                          code: null,
                          pctr: null,
                          mat_group: null,
                          ar1: null,
                          bpc: null,
                          desc: null,
                          code_cost_element: null,
                          code_cost_center: null,
                          costElement: {
                            desc: null,
                            code: null
                          },
                          costCenter: {
                            desc: null,
                            code: null,
                            costNature: {
                              nature_activity: null,
                              category: null,
                              code_cost_center: null
                            }
                          }
                        };
                      }
                      return {
                        ...items,
                        dateStart: this.formatDate(items.start),
                        dateEnd: this.formatDate(items.end),
                        result
                      };
                    })
                  : [];
                val.ioFull = val.dataIO;
                val.showIO = true;
                val.isInformation = true;
              }
              return val;
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again.', 'error');
            }
          }
        })
        .catch(err => {
          if (err.response) {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          } else {
            Swal.fire('Failed!', 'Please try again.', 'error');
          }
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async getData() {
      this.divisionObj = [];
      this.deptObj = [];
      this.houseObj = [];
      this.boObj = [];
      this.setTab();
      this.resetTab();
      await this.getSummaryAmount();
      await this.filterCheck();
      await this.fetchFilterData();
    },
    modalNotes(obj) {
      // modalNotes(item, parentItem, name) {
      this.rejectNotes = true;
      this.modalReject = obj.name;
      if (obj.name === 'house') {
        this.houseId = obj.item.id;
        this.divisiId = obj.parentItem.id;
      } else if (obj.name === 'dept') {
        this.houseId = obj.item.houseId;
        this.deptId = obj.item.id;
        this.divisiId = obj.parentItem.id;
      } else {
        this.budgetOwnerId = obj.id;
      }
    },
    submitNotes() {
      if (this.modalReject === 'house' || this.modalReject === 'dept') {
        this.rejectNotesHouse();
      } else {
        this.rejectNotesBO();
      }
    },
    rejectNotesHouse() {
      let idParam = this.modalReject === 'house' ? this.houseId : this.deptId;
      this.progressDialogLoading = true;
      this.loading = true;
      const payload = {
        notes: this.reason,
        divisi_id: this.divisiId,
        house_id: this.houseId,
        profile_id: this.profile_id,
        type: this.modalReject,
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('spending/notesHouse', { id: idParam, payload })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.tabItems[this.indexFilter].data.map(item => {
              if (this.modalReject === 'house') {
                item.house.map(house => {
                  if (this.houseId === house.id) {
                    house.status = true;
                  }
                  return house;
                });
              } else {
                item.dept.map(dept => {
                  if (this.deptId === dept.id) {
                    dept.status = true;
                  }
                  return dept;
                });
              }
              return item;
            });
            Swal.fire('Success!', 'Note has been submitted.', 'success');
            this.rejectNotes = false;
            this.reason = '';
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    rejectNotesBO() {
      this.progressDialogLoading = true;
      this.loading = true;
      const payload = {
        notes: this.reason
      };
      this.$store
        .dispatch('spending/notesBO', { id: this.budgetOwnerId, payload })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.tabItems[this.indexFilter].data.map(item => {
              item.budgetOwners.map(bo => {
                if (this.budgetOwnerId === bo.id) {
                  bo.status = true;
                }
                return bo;
              });
              return item;
            });
            Swal.fire('Success!', 'Note has been submitted.', 'success');
            this.rejectNotes = false;
            this.reason = '';
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    selectHouse(item) {
      item.houseSelected = [];
      if (!item.selectAllHouse) {
        for (let i in item.house) {
          item.houseSelected.push(item.house[i].id);
        }
      }
      item.selectAllHouse = !item.selectAllHouse;
      if (item.dept.length > 0) {
        this.selectDept(item, item.selectAllHouse);
      }
    },
    selectDept(item, selectAllHouse) {
      item.deptSelected = [];
      if (
        !item.selectAllDept &&
        (selectAllHouse === true || typeof selectAllHouse === 'undefined')
      ) {
        for (let i in item.dept) {
          item.deptSelected.push(item.dept[i].id);
        }
      }
      item.selectAllDept = !item.selectAllDept;
      if (typeof selectAllHouse === 'boolean') {
        item.selectAllDept = selectAllHouse;
      }
      if (item.budgetOwners.length > 0) {
        this.selectBO(item, item.selectAllDept);
      }
    },
    selectBO(item, selectAllDept) {
      item.BOselected = [];
      if (
        !item.selectAllBO &&
        (selectAllDept === true || typeof selectAllDept === 'undefined')
      ) {
        for (let i in item.budgetOwners) {
          item.BOselected.push(item.budgetOwners[i].id);
        }
      }
      item.selectAllBO = !item.selectAllBO;
      if (typeof selectAllDept === 'boolean') {
        item.selectAllBO = selectAllDept;
      }
      if (item.dataIO.length > 0) {
        this.selectIO(item, item.selectAllBO);
      }
    },
    selectIO(item, selectAllBO) {
      item.IOselected = [];
      if (
        !item.selectAllIO &&
        (selectAllBO === true || typeof selectAllBO === 'undefined')
      ) {
        for (let i in item.dataIO) {
          item.IOselected.push(item.dataIO[i].id);
        }
      }
      item.selectAllIO = !item.selectAllIO;
      if (typeof selectAllBO === 'boolean') {
        item.selectAllIO = selectAllBO;
      }
    },
    checkSelect(item, selectedItem, items, itemSelectAll) {
      // kalau setelah select all di table terus ada yang di uncheck di list nya yang select all jadi false
      if (item[itemSelectAll]) {
        if (item[selectedItem].length !== item[items].length) {
          item[itemSelectAll] = true;
        } else {
          item[itemSelectAll] = false;
        }
      }
    },
    confirmApprove(item, index) {
      if (
        this.tabItems[this.tab].data[index].dataIO.length ===
        item.IOselected.length
      ) {
        Swal.fire({
          title: '',
          text: 'Are you sure want to approve this spending?',
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
        }).then(result => {
          if (result.value) {
            if (item.dataIO[0].adhoc) {
              this.approveAdhoc(item);
            } else {
              this.approve(item);
            }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire('Cancelled', 'Approve data cancelled', 'error');
          }
        });
      } else {
        Swal.fire('Failed', 'You must select all IO to approve!', 'error');
      }
    },
    approveAdhoc(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        spending_ids: item.IOselected,
        budget_owner_id: item.dataIO[0].budget_owner_id,
        year: moment(this.year).format('YYYY'),
        profile_id: this.profile_id
      };
      this.$store
        .dispatch('spending/approveAdhoc', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.panel = [];
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: 'Spending has been approved.',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.message.text_en, 'error');
          this.getData();
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    approve(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        spending_ids: item.IOselected,
        budget_owner_id: item.dataIO[0].budget_owner_id,
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('spending/approve', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.panel = [];
          if (data.code === 200) {
            Swal.fire({
              title: 'Success!',
              text: 'Spending has been approved.',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.message.text_en, 'error');
          this.getData();
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    confirmApproveHouseDept(obj) {
      let typeReject = obj.text.toLowerCase();
      Swal.fire({
        title: '',
        text: `Are you sure want to approve this ${typeReject}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.approveHouse(obj.item, obj.type, obj.text);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', `Approve ${typeReject} cancelled`, 'error');
        }
      });
    },
    confirmApproveBO(obj) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to approve this Budget Owner?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          if (obj.budgetOwners[0].adhoc) {
            this.approveBOAdhoc(obj);
          } else {
            this.approveBO(obj);
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Approve data cancelled', 'error');
        }
      });
    },
    approveHouse(item, typeApprove, text) {
      let msg = text.toLowerCase();
      let houseActive = [];
      houseActive.push(item.houseActive);
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        divisi_id: typeApprove === 'dept' ? '' : item.id,
        house_ids: typeApprove === 'house' ? item.houseSelected : houseActive,
        dept_id: typeApprove === 'dept' ? item.deptSelected : '',
        profile_id: this.profile_id,
        type: typeApprove,
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('spending/approveHouse', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.showDialog = false;
            this.reason = '';
            this.selectAllHouse = false;
            if (typeApprove === 'house') {
              item.houseSelected = [];
            } else {
              item.deptSelected = [];
            }
            this.panel = [];
            Swal.fire({
              title: 'Success!',
              text: `This ${msg} has been approved.`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    approveBOAdhoc(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        bo_ids: item.BOselected,
        year: moment(this.year).format('YYYY'),
        profile_id: this.profile_id
      };
      this.$store
        .dispatch('spending/approveBOAdhoc', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.showDialog = false;
            this.reason = '';
            item.selectAllBO = false;
            item.BOselected = [];
            this.panel = [];
            Swal.fire({
              title: 'Success!',
              text: 'Spending has been approved.',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    approveBO(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        budget_owner_ids: item.BOselected,
        year: moment(this.year).format('YYYY')
      };
      this.$store
        .dispatch('spending/approveBO', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.showDialog = false;
            this.reason = '';
            item.selectAllBO = false;
            item.BOselected = [];
            this.panel = [];
            Swal.fire({
              title: 'Success!',
              text: 'Spending has been approved.',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    confirmReject(item) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to reject this spending data?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          // this.showDialog = true;
          this.reject(item);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Reject data cancelled', 'error');
        }
      });
    },
    confirmRejectHouseDept(obj) {
      let typeReject = obj.text.toLowerCase();
      Swal.fire({
        title: '',
        text: `Are you sure want to reject this ${typeReject} ?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.rejectHouse(obj.item, obj.type, obj.text);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', `Reject ${typeReject} cancelled `, 'error');
        }
      });
    },
    confirmRejectBO(item) {
      Swal.fire({
        title: '',
        text: 'Are you sure want to reject this budget owner?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          // this.showDialog = true;
          this.rejectBO(item);
        }
      });
    },
    reject(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        spending_ids: item.IOselected,
        year: moment(this.year).format('YYYY'),
        user_id: this.user.id
      };
      this.$store
        .dispatch('spending/reject', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.showDialog = false;
            this.reason = '';
            item.selectAllIO = false;
            item.IOselected = [];
            this.panel = [];
            Swal.fire({
              title: 'Success!',
              text: 'Spending has been rejected.',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again later', 'error');
            }
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          // this.getData(this.year);
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    rejectHouse(item, typeApprove, text) {
      let msg = text.toLowerCase();
      let houseActive = [];
      houseActive.push(item.houseActive);
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        divisi_id: item.id,
        house_ids: typeApprove === 'house' ? item.houseSelected : houseActive,
        dept_id: typeApprove === 'dept' ? item.deptSelected : '',
        type: typeApprove,
        year: moment(this.year).format('YYYY'),
        profile_id: this.profile_id
      };
      this.$store
        .dispatch('spending/rejectHouse', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            Swal.fire('Success!', `This ${msg} has been rejected.`, 'success');
            this.showDialog = false;
            this.reason = '';
            this.selectAllHouse = false;
            if (typeApprove === 'house') {
              item.houseSelected = [];
            } else {
              item.deptSelected = [];
            }
            this.panel = [];
            Swal.fire({
              title: 'Success!',
              text: `This ${msg} has been rejected.`,
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    rejectBO(item) {
      this.progressDialogLoading = true;
      this.loading = true;
      let payload = {
        budget_owner_ids: item.BOselected,
        year: moment(this.year).format('YYYY'),
        user_id: this.user.id
      };
      this.$store
        .dispatch('spending/rejectBO', payload)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.showDialog = false;
            this.reason = '';
            item.selectAllBO = false;
            item.BOselected = [];
            this.panel = [];
            Swal.fire({
              title: 'Success!',
              text: 'Spending has been rejected.',
              type: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then(result => {
              if (result.value) {
                this.getData();
              }
            });
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    noteModal(value) {
      this.reviewData = value;
      this.progressDialogLoading = false;
      const params = {
        io_code: this.reviewData.code
      };
      this.$store
        .dispatch('spending/editSupportDocs', params)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.isModal = true;
            this.itemsReview = data.data;
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          if (err.response) {
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          } else {
            Swal.fire('Failed!', 'Please try again', 'error');
          }
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    downloadFile(value) {
      let file = encodeURIComponent(value);
      window.open(
        this.baseUrl +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    },
    bgStatus(val) {
      if (!val) {
        return '';
      } else {
        return 'softpink-bg';
      }
    },
    bgStatusActive(val, valActive) {
      if (valActive) {
        return 'active-io';
      } else {
        if (!val) {
          return '';
        } else {
          return 'softpink-bg';
        }
      }
    },
    rowActive(val) {
      if (val) {
        return 'primary--text';
      }
    },
    bgActive(val1, val2) {
      if (val1 == val2) {
        return 'primary--text';
      } else {
        return '';
      }
    },
    changeColor(active, status) {
      if (active && status) {
        return 'whitestatus redstatus primary--text';
      } else if (status) {
        return 'redstatus';
      } else if (active) {
        return 'whitestatus primary--text';
      } else if (active == undefined) {
        return 'whitestatus';
      } else {
        return 'whitestatus';
      }
    },
    checkDivision(item) {
      // let name = item.name.toLowerCase();
      if (item.name === 'Marketing' || item.divisi_id === 1) return true;
      return false;
    },
    checkColumnActive(item) {
      let month;
      if (item.month === 'total') {
        month = 'Full Year IO';
      } else {
        month = item.month.charAt(0).toUpperCase() + item.month.slice(1);
      }
      return this.columnActive.includes(month);
      // return item.month === 'total'
      //   ? 'Full Year IO'
      //   : item.month.charAt(0).toUpperCase() + item.month.slice(1);
    },
    selectAllColumn() {
      if (this.selectedAllColumn) {
        this.selectedAllColumn = false;
        this.columnActive = [];
      } else {
        this.selectedAllColumn = true;
        this.columnActive = this.spendingColumn;
      }
    },
    getAscSort(obj) {
      // sorting non nested
      this.tabItems[this.indexFilter].data[obj.tableIndex].dataIO.sort(
        this.dynamicSort(obj.fieldName)
      );
    },
    getNestedSort(obj) {
      this.nestedSort(
        obj.fieldName,
        this.tabItems[this.indexFilter].data[obj.tableIndex].dataIO
      );
    },
    searchCln(obj) {
      let nameField = obj.fieldName;
      let arr = this.tabItems[this.indexFilter].data[obj.tableIndex].ioFull;
      let valSearch = Array.isArray(obj.value)
        ? obj.value.join('|').toLowerCase()
        : obj.value.toLowerCase();
      if (!nameField.includes('.')) {
        /*search array of object*/
        if (nameField === 'start') {
          nameField = 'dateStart';
        } else if (nameField === 'end') {
          nameField = 'dateEnd';
        }
        this.tabItems[this.indexFilter].data[
          obj.tableIndex
        ].dataIO = arr.filter(function(a) {
          if (a[nameField] !== null) {
            if (Array.isArray(obj.value)) {
              return obj.value.includes(a[nameField].toString());
            } else {
              return a[nameField]
                .toString()
                .toLowerCase()
                .match(valSearch);
            }
          }
        });
      } else {
        /*search array of nested object*/
        let arrObj = nameField.split('.');
        if (arrObj.length === 2) {
          this.tabItems[this.indexFilter].data[
            obj.tableIndex
          ].dataIO = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(a[arrObj[0]][arrObj[1]].toString());
              } else {
                return a[arrObj[0]][arrObj[1]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
            }
          });
        } else if (arrObj.length === 3) {
          this.tabItems[this.indexFilter].data[
            obj.tableIndex
          ].dataIO = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
              // return a[arrObj[0]][arrObj[1]][arrObj[2]]
              //   .toString()
              //   .toLowerCase()
              //   .match(valSearch);
            }
          });
        } else if (arrObj.length === 4) {
          this.tabItems[this.indexFilter].data[
            obj.tableIndex
          ].dataIO = arr.filter(function(a) {
            if (a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]] !== null) {
              if (Array.isArray(obj.value)) {
                return obj.value.includes(
                  a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]].toString()
                );
              } else {
                return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
                  .toString()
                  .toLowerCase()
                  .match(valSearch);
              }
              // return a[arrObj[0]][arrObj[1]][arrObj[2]][arrObj[3]]
              //   .toString()
              //   .toLowerCase()
              //   .match(valSearch);
            }
          });
        }
      }
    },
    resetTab() {
      this.tabItems = [];
      let data = [];
      for (let i = 0; i < this.filters.length; i++) {
        this.tabItems.push({ data: data });
      }
    },
    getDivision() {
      return this.$store
        .dispatch('advanceFilter/getDivision')
        .then(data => {
          if (data.code === 200) {
            this.divisionList = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getHouses() {
      this.isDisabledHouse = true;
      return this.$store
        .dispatch('advanceFilter/getHouse')
        .then(data => {
          this.isDisabledHouse = false;
          if (data.code === 200) {
            this.houseList = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getDept() {
      this.isDisabledDept = true;
      let division = this.division_ids_param;
      let house = this.house_ids_param;
      let params = {
        division_id: division,
        house_id: house
      };
      return this.$store
        .dispatch('advanceFilter/getDept', params)
        .then(data => {
          this.isDisabledDept = false;
          if (data.code === 200) {
            this.deptList = data.data;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    getBO() {
      this.isDisabledBo = true;
      let dept = this.dept_ids_param;
      let house = this.house_ids_param;
      if (this.isLoggedInAsDeptHead && !this.userMapping.house_id) {
        house = arrayToParam(this.houseList.map(item => item.id));
      }
      let params = {
        house_id: house,
        department_id: dept
      };
      return this.$store
        .dispatch('advanceFilter/getBO', params)
        .then(data => {
          this.isDisabledBo = false;
          if (data.code === 200) {
            this.boList = data.data;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    },
    async filterCheck() {
      this.progressDialogLoading = true;
      let profName = JSON.parse(localStorage.getItem('userProfile'));
      switch (this.filters.length) {
        case 1:
          this.showFilterDivision = false;
          this.showFilterHouse = false;
          this.showFilterDept = false;
          this.showFilterBo = false;
          break;
        case 2: // BO
          this.showFilterDivision = false;
          this.showFilterHouse = false;
          this.showFilterDept = false;
          this.showFilterBo = true;
          await this.getBO();
          break;
        case 3: // Dept
          this.showFilterDivision = false;
          this.showFilterHouse = false;
          this.showFilterDept = true;
          this.showFilterBo = true;
          await this.getDept();
          break;
        case 4: // House
          this.showFilterDivision = false;
          this.showFilterHouse = true;
          this.showFilterDept = true;
          this.showFilterBo = true;
          break;
      }
      if (profName.desc.includes('Finance')) {
        this.showFilterDivision = true;
        await this.getDivision();
      } else {
        this.showFilterDivision = false;
        await this.getHouses();
      }
      this.progressDialogLoading = false;
    },
    resetDiv() {
      if (this.initializing || !this.showFilterDivision) return;

      console.info('resetting division...');
      this.divisionList = [];
      this.divisionObj = [];
    },
    resetHouse() {
      if (this.initializing || !this.showFilterHouse) return;

      console.info('resetting house...');
      this.houseList = [];
      this.houseObj = [];
    },
    resetDept() {
      if (this.initializing || !this.showFilterDept) return;

      console.info('resetting dept...');
      this.deptList = [];
      this.deptObj = [];
    },
    resetBO() {
      // if (!this.showFilterBo) return;

      console.info('resetting bo...');
      this.boObj = [];
      this.boList = [];
    },
    reset() {
      this.resetDiv();
      this.resetHouse();
      this.resetDept();
      this.resetBO();
      this.filterCheck();
    },
    filterGroup() {
      if (this.isLoggedInAsFinance) {
        this.filter = 'divisi';
        this.filterWdh = this.wdhFilter('divisi');
      }
      if (this.isLoggedInAsDirector) {
        this.filter = 'house';
        this.filterWdh = this.wdhFilter('house');
      }
      if (this.isLoggedInAsBrandHead) {
        this.filter = 'department';
        this.filterWdh = this.wdhFilter('department');
      }
      if (this.isLoggedInAsDeptHead) {
        this.filter = 'budgetOwner';
        this.filterWdh = this.wdhFilter('budgetOwner');
      }
    },
    resetFilter() {
      this.filterGroup();
      this.reset();
    },
    getFiltered(name, index) {
      if (!name.includes('.')) {
        // let dataFiltered = this.items[index].ioFull.reduce((result, arr) => {
        let dataFiltered = this.tabItems[this.indexFilter].data[
          index
        ].ioFull.reduce((result, arr) => {
          result[arr[name]] = [...(result[arr[name]] || []), arr];
          return result;
        }, {});
        return Object.keys(dataFiltered);
      } else {
        let nameField = name.split('.');
        let dataFiltered = [];
        switch (nameField.length) {
          case 2:
            dataFiltered = this.tabItems[this.indexFilter].data[
              index
            ].ioFull.reduce((result, arr) => {
              result[arr[nameField[0]][nameField[1]]] = [
                ...(result[arr[nameField[0]][nameField[1]]] || []),
                arr
              ];
              return result;
            }, {});
            break;
          case 3:
            dataFiltered = this.tabItems[this.indexFilter].data[
              index
            ].ioFull.reduce((result, arr) => {
              result[arr[nameField[0]][nameField[1]][nameField[2]]] = [
                ...(result[arr[nameField[0]][nameField[1]][nameField[2]]] ||
                  []),
                arr
              ];
              return result;
            }, {});
            break;
          case 4:
            dataFiltered = this.tabItems[this.indexFilter].data[
              index
            ].ioFull.reduce((result, arr) => {
              result[
                arr[nameField[0]][nameField[1]][nameField[2]][nameField[3]]
              ] = [
                ...(result[
                  arr[nameField[0]][nameField[1]][nameField[2]][nameField[3]]
                ] || []),
                arr
              ];
              return result;
            }, {});
            break;
        }
        return Object.keys(dataFiltered);
      }
    }
  }
};
</script>
<style>
.v-input--selection-controls {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.drawer-menu--scroll {
  max-height: 400px;
  overflow: auto;
}
.drawer-table--scroll {
  max-height: 150px;
  overflow: auto;
}
.drawer-column--scroll {
  max-height: 250px;
  overflow: auto;
}
td {
  vertical-align: middle !important;
}
.theme--light.v-tabs-items {
  background: transparent !important;
}
.tab-spending .v-slide-group__wrapper {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
.v-menu__content {
  background: #fff !important;
}
.menuColumn {
  max-height: 250px;
}
tr:hover {
  background-color: #f5f5f5 !important;
}
</style>
